import React from 'react';
import {useEffect, useState} from "react";
import axiosClient from "../axios-client.js";

const Coaches = () => {
  const [coaches, setCoaches] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCoaches();
  }, [])

  const getCoaches = () => {
    setLoading(true)
    axiosClient.get('/coaches-active')
      .then(({ data }) => {
        setLoading(false)
        setCoaches(data.data)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <div className='container'>
      <div className='mt-4'>
        <p className='calendario-titulo center mt-5'>Conoce al equipo de coaches Psycle</p>
      </div>

      {loading ? (
        <div className='loading-container center'>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
      <div className='row g-3 mb-5'>
        {coaches.map((c) => (
          <div className='col-6 col-sm-6 col-lg-3' key={c.id}>
            <div className='coach-card'>
              <div className='coach-card__img-wrap'>
                {c.image ? (
                  <img
                    className="coach-card__img"
                    src={require(`../images/coaches/${c.image}`)}
                    alt={c.name}
                  />
                ) : (
                  <div className="avatar-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.5">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                )}
              </div>
              <p className='coach-card__name'>{c.name}</p>
            </div>
          </div>
        ))}
      </div>
      )}

    </div>
  );
};

export default Coaches;